"use client";
import React, { useState } from "react";
import banner from '../../../Assets/images/BannerImages/immigration.png';
import { Collapse } from "@mui/material";
import Banner from "../../../Components/Common/Banner";
import { IoArrowDownSharp } from "react-icons/io5";

const ImmigrationSupport = () => {
    const faqs = [
        {
            question: "Q. Am I eligible for OPT?",
            answer:
                "To be eligible for OPT, you must be an F-1 student who has been lawfully enrolled on a full-time basis for one full academic year at a U.S. college, university, conservatory, or seminary.",
        },
        {
            question: "Q. When can I apply for OPT?",
            answer:
                "You can apply for OPT up to 90 days before your program end date and up to 60 days after your program end date.",
        },
        {
            question:
                "Q. What does the immigration service consider completion of studies?",
            answer:
                "To be eligible for OPT, you must be an F-1 student who has been lawfully enrolled on a full-time basis for one full academic year at a U.S. college, university, conservatory, or seminary.",
        },
        {
            question:
                "Q. Do I have to use the entire 12-month OPT period at once, or may I use it increments?",
            answer:
                "You can apply for OPT up to 90 days before your program end date and up to 60 days after your program end date.",
        },
        {
            question: "Q. May I cancel my OPT application once I have applied?",
            answer:
                "To be eligible for OPT, you must be an F-1 student who has been lawfully enrolled on a full-time basis for one full academic year at a U.S. college, university, conservatory, or seminary.",
        },
        {
            question:
                "Q. How does OPT and STEM OPT Extension affect my travel plans?",
            answer:
                "You can apply for OPT up to 90 days before your program end date and up to 60 days after your program end date.",
        },
        {
            question: "Q. What is the new OPT Extension rule of unemployment days?",
            answer:
                "You can apply for OPT up to 90 days before your program end date and up to 60 days after your program end date.",
        },
        {
            question: "Q. What about the Cap-Gap extension?",
            answer:
                "You can apply for OPT up to 90 days before your program end date and up to 60 days after your program end date.",
        },
        {
            question: "  Q. Who qualifies for an H-1B cap-gap extension?",
            answer:
                "You can apply for OPT up to 90 days before your program end date and up to 60 days after your program end date.",
        },
    ];

    const [openIndex, setOpenIndex] = useState(0);

    const toggleAnswer = (index) => {
        if (openIndex === index) {
            setOpenIndex(null);
        } else {
            setOpenIndex(index);
        }
    };
    return (
        <React.Fragment>
            <Banner pageName="IMMIGRATION SUPPORT" breadcrummbs="Home / Services / IMMIGRATION SUPPORT" bgimage={banner} />
            <div>
                <div className="mx-auto max-w-7xl px-12 sm:px-6 lg:px-8 py-20 tracking-wider">
                    <div className="w-full px-20 flex flex-col justify-center items-center">
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className="mb-1 bg-blue-100 lg:w-[70%] w-full focus:outline-none px-6 py-2"
                            >
                                <button
                                    onClick={() => toggleAnswer(index)}
                                    className="text-md font-semibold bg-transparent text-left flex items-center justify-between w-full"
                                >
                                    {faq.question}
                                    <IoArrowDownSharp />
                                </button>
                                <Collapse in={openIndex === index}>
                                    <div className="p-2">
                                        <p>{faq.answer}</p>
                                    </div>
                                </Collapse>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ImmigrationSupport;
